import { ColumnType } from "../../types/dataGridTypes";
import { IPageLayoutType } from "../../types/pageLayoutTypes";

export const useEnrollmentDetails = () => {
  const rowData = [
    {
      id: "3333-222",
      studyID: "ONC-NSCLC-2024-01",
      siteID: "S1001",
      cancerType: "Lung Cancer",
      enrollDate: "2024/07/02",
      isNew: true,
    },
    {
      id: "3333-223",
      studyID: "ONC-NSCLC-2024-01",
      siteID: "S1002",
      cancerType: "Brain Cancer",
      enrollDate: "2024/07/02",
      isUpdated: true,
    },
    {
      id: "2222-456",
      badge: "",
      studyID: "MPR-NSCLC-2024-01",
      siteID: "S1004",
      cancerType: "Blood Cancer",
      enrollDate: "2024/07/02",
    },
    {
      id: "2222-548",
      badge: "",
      studyID: "ONC-NSCLC-2024-01",
      siteID: "S1001",
      cancerType: "Bone Cancer",
      enrollDate: "2024/07/02",
    },
  ];
  const patientDetailsContentJson: IPageLayoutType[] = [
    {
      title: "",
      description: "",
      noCard: true,
      content: [
        {
          label: "DOB",
          value: "01-03-1996",
          size: {
            mediumScreen: 12,
            extraSmallScreen: 12,
          },
        },
        {
          label: "Gender",
          value: "Male",
          size: {
            mediumScreen: 12,
            extraSmallScreen: 12,
          },
        },
      ],
    },
  ];
  const patientDetailsDataContentJson: IPageLayoutType[] = [
    {
      title: "",
      description: "",
      content: [
        {
          label: "Clinical History",
          value: "Lung Cancer",
          size: {
            mediumScreen: 4,
            extraSmallScreen: 12,
          },
        },
        {
          label: "Enrolled Date",
          value: "01-01-2024",
          size: {
            mediumScreen: 4,
            extraSmallScreen: 12,
          },
        },
        {
          label: "Enrolled Site",
          value: "Site945",
          size: {
            mediumScreen: 4,
            extraSmallScreen: 12,
          },
        },
        {
          label: "Enrolled Site Address",
          value: "230 Clinical Drive, Suite 123, New York, NY 12345",
          size: {
            mediumScreen: 4,
            extraSmallScreen: 12,
          },
        },
        {
          label: "Enrolled Site Phone Number",
          value: "123-456-7890",
          size: {
            mediumScreen: 4,
            extraSmallScreen: 12,
          },
        },
        {
          label: "Enrolled Site Email",
          value: "email@numberone.com",
          size: {
            mediumScreen: 4,
            extraSmallScreen: 12,
          },
        },
        {
          label: "Treatment and Medical Record",
          value: "Attachment Chip",
          size: {
            mediumScreen: 12,
            extraSmallScreen: 12,
          },
        },
      ],
    },
  ];
  const enrollmentDetailscolumns: ColumnType[] = [
    {
      field: "id",
      headerName: "Sample ID",
      minWidth: 120,
      flex: 1,
    },
    {
      field: "sampleType",
      headerName: "Sample Type",
      minWidth: 160,
      flex: 1,
    },
    {
      field: "specimenType",
      headerName: "Specimen Type",
      minWidth: 120,
      flex: 1,
    },
    {
      field: "collectionDate",
      headerName: "Collection Date",
      minWidth: 120,
      flex: 1,
    },
    {
      field: "info",
      headerName: "Info",
      minWidth: 120,
      flex: 1,
    },
    {
      field: "actionsColumn",
      width: 90,
      type: "actions",
      cmp: "actions",
      headerName: "Action",
      sortable: false,
      filterable: false,
      actionsArray: [
        { icon: "Edit", label: "Edit", key: "action_edit" },
        { icon: "Delete", label: "Delete", key: "action_delete" },
      ],
    },
  ];
  return {
    rowData,
    patientDetailsContentJson,
    patientDetailsDataContentJson,
    enrollmentDetailscolumns,
  };
};
